<template>
  <!--   This component just builds the appropriate html / css framework
  for a lazy scroller on the x axis. It does not provide any logic
  and is just a rendering template
 -->
  <div
    ref="main"
    :class="scroll_container_classes"
    @[maybescroll]="scroll_handler"
  >
    <component
      :is="render.container"
      ref="dyncomp"
      :class="container_classes"
      :style="container_style"
    >
      <template v-if="render.initialized">
        <template
          v-for="nbx in _.range(render.component_start, render.component_stop)"
        >
          <slot name="default" :nbx="nbx" :initialized="true"></slot>
        </template>
      </template>
      <template v-else>
        <slot name="default" :nbx="0" :initialized="false"></slot>
      </template>
    </component>
  </div>
</template>

<script>
import _ from 'lodash'

// *****************************************************************************

export default {
  name: 'LazyListX',
  props: ['render'],
  computed: {
    _() {
      return _
    },
    maybescroll() {
      const res = this.render.scroll ? '&scroll' : null
      return res
    },
    scroll_container_classes() {
      let scroll_container_classes = ['synaplus-cosmo-scroll-container']
      if (this.render.scroll) {
        scroll_container_classes.push('synaplus-cosmo-add-scrollbar-x')
      } else {
        scroll_container_classes.push('synaplus-cosmo-no-scrollbar-x')
      }
      return scroll_container_classes
    },
    container_classes() {
      let res = ['synaplus-cosmo-scroll-containee']
      res = res.concat(this.render.container_class)
      return res
    },
    container_style() {
      return {
        'padding-left': `${this.render.padding_low}px`,
        'padding-right': `${this.render.padding_high}px`,
        width: `${this.render.really_rendered_size}px`,
      }
    },
  },
  mounted() {
    if (!this.render.initialized) {
      this.$emit('initialize', this.$refs.main, this.$refs.dyncomp.firstChild)
    }
  },
  updated() {
    this.$emit('updated')
  },
  methods: {
    scroll_handler(evt) {
      this.$emit('scrollx', evt)
    },
  },
}
</script>
